import * as React from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import './assets/css/NavMenu.css';
import { IAppState } from '../../../store';
import { RouteComponentProps } from 'react-router';
import companyLogo from './assets/img/logo.png';
import companyLogor from './assets/img/logo-r.png';


export interface IFooterState {
    readonlyParamProps: string;
};

type layoutProps = IFooterState & RouteComponentProps;
class  Footer extends React.PureComponent<layoutProps> {
    public state = {
        path: ""
    };
    constructor(props) {
        super(props);
    }
    /*   async componentDidMount() {
          const { location: { search } } = this.props;
          this.state.path = search;
      } */
    public render() {
        //  const userJwt = useSelector((state: IAppState) => state.UserState?state.UserState.jwt:null);
        return (

           <footer id="footer" className="footer">
             
            <div className="footer-top">
              <div className="container">
                <div className="row gy-4">
                  <div className="col-lg-6 col-md-12 footer-info">
                    <a href="/" className="logo d-flex align-items-center">
                      <img src={companyLogor} alt=""/>
                      <span> شرکت  تجارت الکترونیک هوشمند تمدن
</span>
 
                    </a>
                    <p>
                    شرکت دانش بنیان تجارت الکترونیک هوشمند تمدن، متشکل از تیمی نخبه و جوانانی متخصص در حوزه فناوری اطلاعات، بازار سرمایه و سیستم بانکی است که راهکارها و حل مشکلات نهادهای مالی، شرکت ها، کارگزاری ها، صندوق های سرمایه گذاری و ... را در خصوص حوزه پرداخت فراهم کرده است.



                      
                      </p>
                    <div className="social-links mt-3">
       
                      <a href="#" className="instagram"><i className="bi bi-instagram"></i></a>
                      <a href="#" className="linkedin"><i className="bi bi-linkedin"></i></a>
                    </div>
                  </div>
        
                  <div className="col-lg-3 col-12 footer-links">
                    <h4>پیوند های مفید</h4>
                    <ul>
                      <li><i className="bi bi-chevron-left"></i> <a target='_blank' href="https://www.seo.ir/"> سازمان بورس و اوراق بهادار  </a></li>
                      <li><i className="bi bi-chevron-left"></i> <a target='_blank' href="https://tamadonib.com"> شرکت تأمین سرمایه تمدن</a></li>
                      <li><i className="bi bi-chevron-left"></i> <a target='_blank' href="https://tamadonbroker.ir/">   شرکت کارگزاری تامین سرمایه تمدن     </a></li>
                      <li><i className="bi bi-chevron-left"></i> <a target='_blank' href="https://esahra.ir/"> شرکت ره پویان پردازش گستر صحرا</a></li>

                      <li><i className="bi bi-chevron-left"></i> <a target='_blank' href="https://ibshop.ir/">  شرکت آسان سرمایه گستر ایرانیان
                      </a></li>
 
                    </ul>
                  </div>
        
                
        
                  <div className="col-lg-3 col-md-12 footer-contact text-center text-md-start">
                    <h4>  تماس با ما</h4>
                    <p>
تهران، میدان آرژانتین، خیابان 16 غربی، پلاک 8، طبقه 2                      <br/><br/>
                      <strong>تلفن:</strong>  58169998 - 021<br/>
                      <strong>ایمیل:</strong> info@TamadonSec.ir

<br/>
                    </p>
        
                  </div>
        
                </div>
              </div>
            </div>
        
            <div className="container">
              <div className="copyright">
                &copy; Copyright <strong><span> Tamadon Smart E-Commerce  </span></strong>. All Rights Reserved
              </div>
              <div className="credits">
              
                Version : 1.0.3
              </div>
            </div>
          </footer> 
     

         );
    }
}
export default connect((state: IAppState) => state.UserState)(Footer as any);